export default __webpack_public_path__ + "static/media/11d.ac4ab7ed.png";